(function () {
  // v2: subcategory + focus_keyword removed as visible facets (both remain in
  // query_by, so the search box still matches them); "Find an article" title
  // autocomplete injected into the filter panel; " | VanillaGoods" suffix
  // stripped from displayed titles.
  const FACET_FIELDS = ['primary_topic', 'region', 'author'];
  const HIDDEN_FACETS = ['subcategory', 'focus_keyword', 'secondary_keywords'];
  const FEATURED_SORT = 'display_order:asc,published_at:desc';
 
  function debounce(fn, delay) {
    let timer = null;
    return function debounced() {
      const args = arguments;
      const context = this;
      clearTimeout(timer);
      timer = setTimeout(function () {
        fn.apply(context, args);
      }, delay);
    };
  }
 
  function escapeHtml(value) {
    return String(value || '')
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#39;');
  }
 
  function displayTitle(value) {
    return String(value || '').split(' | ')[0];
  }
 
  function normalizePath(path) {
    if (!path) return '';
    const withSlash = path.startsWith('/') ? path : '/' + path;
    return withSlash.endsWith('/') ? withSlash.slice(0, -1) : withSlash;
  }
 
  function quoteFilterValue(value) {
    const escaped = String(value || '').replaceAll('`', '\\`').trim();
    return '`' + escaped + '`';
  }
 
  function slugToLabel(value) {
    return String(value || '')
      .replaceAll('_', ' ')
      .replaceAll('-', ' ')
      .replace(/\b\w/g, function (m) {
        return m.toUpperCase();
      });
  }
 
  function buildTypesenseSearchUrl(config) {
    const protocol = (config.protocol || 'https').trim();
    const host = (config.host || '').trim();
    const port = (config.port || '').trim();
    const path = normalizePath((config.path || '').trim());
    const collection = (config.collection || '').trim();
    if (!host || !collection) return '';
 
    const portSegment = port ? ':' + port : '';
    return (
      protocol +
      '://' +
      host +
      portSegment +
      path +
      '/collections/' +
      encodeURIComponent(collection) +
      '/documents/search'
    );
  }
 
  function parseFacetCounts(facetCounts) {
    const facetMap = {};
    if (!Array.isArray(facetCounts)) return facetMap;
 
    facetCounts.forEach(function (facetEntry) {
      const fieldName = facetEntry.field_name;
      if (!fieldName || !Array.isArray(facetEntry.counts)) return;
      facetMap[fieldName] = facetEntry.counts.map(function (item) {
        return {
          value: item.value,
          count: Number(item.count || 0)
        };
      });
    });
    return facetMap;
  }
 
  function getSelectedSet(root, field) {
    if (!root._blogSearchState.selectedFacets[field]) {
      root._blogSearchState.selectedFacets[field] = new Set();
    }
    return root._blogSearchState.selectedFacets[field];
  }
 
  function hideRemovedFacets(root) {
    HIDDEN_FACETS.forEach(function (field) {
      const el = root.querySelector('[data-blog-facet="' + field + '"]');
      if (!el) return;
      const block = el.closest('.blog-search__facet') || el.closest('details') || el.parentElement;
      if (block) block.hidden = true;
    });
  }
 
  function buildTitleJump(root) {
    const filters = root.querySelector('.blog-search__filters');
    if (!filters) return;
 
    const wrap = document.createElement('div');
    wrap.className = 'blog-search__titlejump';
    const inputId = 'vg-titlejump-' + (root.dataset.sectionId || 'x');
    wrap.innerHTML =
      '<label class="blog-search__titlejump-label" for="' + inputId + '">Find an article</label>' +
      '<div class="blog-search__titlejump-box">' +
      '<input type="text" id="' + inputId + '" class="blog-search__titlejump-input" placeholder="Start typing a title\u2026" autocomplete="off">' +
      '<ul class="blog-search__titlejump-list" hidden></ul>' +
      '</div>';
    filters.insertBefore(wrap, filters.firstChild);
 
    const input = wrap.querySelector('input');
    const list = wrap.querySelector('ul');
 
    const lookup = debounce(async function () {
      const q = input.value.trim();
      if (q.length < 2) {
        list.hidden = true;
        list.innerHTML = '';
        return;
      }
      const state = root._blogSearchState;
      const endpoint = buildTypesenseSearchUrl(state.config);
      if (!endpoint) return;
      const qs = new URLSearchParams({
        q: q,
        query_by: 'title',
        per_page: '8',
        page: '1'
      }).toString();
      try {
        const response = await fetch(endpoint + '?' + qs, {
          headers: { 'X-TYPESENSE-API-KEY': state.config.searchKey }
        });
        if (!response.ok) throw new Error('title lookup failed: ' + response.status);
        const payload = await response.json();
        const hits = Array.isArray(payload.hits) ? payload.hits : [];
        if (!hits.length) {
          list.innerHTML = '<li class="blog-search__titlejump-empty">No matching titles</li>';
          list.hidden = false;
          return;
        }
        list.innerHTML = hits
          .map(function (h) {
            const doc = h.document || {};
            return (
              '<li><a href="' +
              escapeHtml(doc.url || '#') +
              '">' +
              escapeHtml(displayTitle(doc.title)) +
              '</a></li>'
            );
          })
          .join('');
        list.hidden = false;
      } catch (error) {
        list.hidden = true;
        console.error(error);
      }
    }, 200);
 
    input.addEventListener('input', lookup);
    input.addEventListener('focus', function () {
      if (list.innerHTML) list.hidden = false;
    });
    document.addEventListener('click', function (event) {
      if (!wrap.contains(event.target)) list.hidden = true;
    });
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') list.hidden = true;
    });
  }
 
  function renderRegionSelect(root, container, facetValues) {
    const selected = getSelectedSet(root, 'region');
    const current = selected.size > 0 ? Array.from(selected)[0] : '';
    const merged = new Map();
 
    (facetValues || []).forEach(function (entry) {
      merged.set(String(entry.value), Number(entry.count || 0));
    });
    if (current && !merged.has(current)) merged.set(current, 0);
 
    const items = Array.from(merged.entries()).sort(function (a, b) {
      if (a[0] === b[0]) return 0;
      return a[0] < b[0] ? -1 : 1;
    });
 
    let html = '<select data-blog-region-select class="blog-search__region-select" aria-label="Filter by region">';
    html += '<option value="">All regions</option>';
    items.forEach(function (pair) {
      const value = pair[0];
      const count = pair[1];
      html +=
        '<option value="' + escapeHtml(value) + '"' + (value === current ? ' selected' : '') + '>' +
        escapeHtml(slugToLabel(value)) + ' (' + count + ')' +
        '</option>';
    });
    html += '</select>';
    container.innerHTML = html;
  }
 
  function renderFacet(root, field, facetValues) {
    const container = root.querySelector('[data-blog-facet="' + field + '"]');
    if (!container) return;
 
    if (field === 'region') {
      renderRegionSelect(root, container, facetValues);
      return;
    }
 
    const selected = getSelectedSet(root, field);
    const merged = new Map();
 
    (facetValues || []).forEach(function (entry) {
      merged.set(String(entry.value), Number(entry.count || 0));
    });
    selected.forEach(function (value) {
      if (!merged.has(value)) {
        merged.set(value, 0);
      }
    });
 
    const items = Array.from(merged.entries()).sort(function (a, b) {
      if (a[0] === b[0]) return 0;
      return a[0] < b[0] ? -1 : 1;
    });
 
    if (items.length === 0) {
      container.innerHTML = '<p class="blog-search__facet-empty">No values</p>';
      return;
    }
 
    const html = items
      .map(function (pair, index) {
        const value = pair[0];
        const count = pair[1];
        const checked = selected.has(value) ? ' checked' : '';
        const id = 'facet-' + root.dataset.sectionId + '-' + field + '-' + index;
        return (
          '<div class="blog-search__facet-item">' +
          '<label for="' +
          id +
          '">' +
          '<input type="checkbox" data-blog-facet-input data-field="' +
          escapeHtml(field) +
          '" value="' +
          escapeHtml(value) +
          '"' +
          checked +
          ' id="' +
          id +
          '">' +
          '<span>' +
          escapeHtml(slugToLabel(value)) +
          '</span>' +
          '</label>' +
          '<span class="blog-search__facet-count">' +
          escapeHtml(count) +
          '</span>' +
          '</div>'
        );
      })
      .join('');
 
    container.innerHTML = '<div class="blog-search__facet-items">' + html + '</div>';
  }
 
  function buildFilterBy(root) {
    const state = root._blogSearchState;
    const filters = [];
 
    FACET_FIELDS.forEach(function (field) {
      const selected = getSelectedSet(root, field);
      if (selected.size === 0) return;
 
      const values = Array.from(selected).map(quoteFilterValue);
      if (values.length === 1) {
        filters.push(field + ':=' + values[0]);
      } else {
        filters.push(field + ':=[' + values.join(',') + ']');
      }
    });
 
    if (state.readTimeFilter) {
      if (state.readTimeFilter.startsWith('<')) {
        filters.push('read_time_minutes:<' + state.readTimeFilter.slice(1));
      } else if (state.readTimeFilter.startsWith('>=')) {
        filters.push('read_time_minutes:>=' + state.readTimeFilter.slice(2));
      }
    }
 
    if (state.wordCountFilter) {
      if (state.wordCountFilter.startsWith('<')) {
        filters.push('word_count:<' + state.wordCountFilter.slice(1));
      } else if (state.wordCountFilter.startsWith('>=')) {
        filters.push('word_count:>=' + state.wordCountFilter.slice(2));
      }
    }
 
    return filters.join(' && ');
  }
 
  function serializeQueryParams(params) {
    const urlParams = new URLSearchParams();
    Object.entries(params).forEach(function (entry) {
      const key = entry[0];
      const value = entry[1];
      if (value === undefined || value === null || value === '') return;
      urlParams.set(key, String(value));
    });
    return urlParams.toString();
  }
 
  function setStatus(root, status) {
    const loadingEl = root.querySelector('[data-blog-loading]');
    const errorEl = root.querySelector('[data-blog-error]');
    const emptyEl = root.querySelector('[data-blog-empty]');
 
    loadingEl.hidden = status !== 'loading';
    errorEl.hidden = status !== 'error';
    emptyEl.hidden = status !== 'empty';
  }
 
  function renderCards(root, hits) {
    const results = root.querySelector('[data-blog-results]');
    if (!results) return;
 
    const cards = (hits || [])
      .map(function (hitWrapper) {
        const doc = hitWrapper.document || {};
        const url = doc.url || '#';
        const title = displayTitle(doc.title || 'Untitled article');
        const summary = doc.summary || '';
        const imageUrl = doc.image_url || '';
        const imageAlt = doc.image_alt || title;
 
        const chips = [];
        if (doc.primary_topic) chips.push(slugToLabel(doc.primary_topic));
        if (doc.region) chips.push(slugToLabel(doc.region));
        if (doc.read_time_minutes) chips.push(String(doc.read_time_minutes) + ' min read');
 
        const imageHtml = imageUrl
          ? '<div class="blog-search__card-image-wrap"><img class="blog-search__card-image" src="' +
            escapeHtml(imageUrl) +
            '" alt="' +
            escapeHtml(imageAlt) +
            '" loading="lazy"></div>'
          : '';
 
        const chipHtml =
          chips.length > 0
            ? '<div class="blog-search__card-meta">' +
              chips
                .map(function (chip) {
                  return '<span class="blog-search__chip">' + escapeHtml(chip) + '</span>';
                })
                .join('') +
              '</div>'
            : '';
 
        return (
          '<article class="blog-search__card">' +
          '<a class="blog-search__card-link" href="' +
          escapeHtml(url) +
          '">' +
          imageHtml +
          '<div class="blog-search__card-body">' +
          '<h3 class="blog-search__card-title">' +
          escapeHtml(title) +
          '</h3>' +
          (summary
            ? '<p class="blog-search__card-summary">' + escapeHtml(summary) + '</p>'
            : '') +
          chipHtml +
          '</div>' +
          '</a>' +
          '</article>'
        );
      })
      .join('');
 
    results.innerHTML = cards;
  }
 
  function renderMeta(root, payload) {
    const summaryEl = root.querySelector('[data-blog-summary]');
    const paginationEl = root.querySelector('[data-blog-pagination]');
    const pageLabelEl = root.querySelector('[data-blog-page-label]');
    const prevBtn = root.querySelector('[data-blog-prev]');
    const nextBtn = root.querySelector('[data-blog-next]');
 
    if (!summaryEl || !paginationEl || !pageLabelEl || !prevBtn || !nextBtn) return;
 
    const found = Number(payload.found || 0);
    const perPage = Number(payload.request_params && payload.request_params.per_page) || root._blogSearchState.perPage;
    const page = Number(payload.page || 1);
    const totalPages = Math.max(1, Math.ceil(found / perPage));
 
    summaryEl.textContent = found.toLocaleString() + ' article' + (found === 1 ? '' : 's');
    pageLabelEl.textContent = 'Page ' + page + ' of ' + totalPages;
 
    paginationEl.hidden = totalPages <= 1;
    prevBtn.disabled = page <= 1;
    nextBtn.disabled = page >= totalPages;
 
    root._blogSearchState.page = page;
    root._blogSearchState.totalPages = totalPages;
  }
 
  function effectiveSortBy(state, query) {
    if (state.sortBy === FEATURED_SORT && query !== '*') return '';
    return state.sortBy || '';
  }

  async function runSearch(root) {
    const state = root._blogSearchState;
    const endpoint = buildTypesenseSearchUrl(state.config);
    if (!endpoint || !state.config.searchKey || !state.config.queryBy) return;
 
    setStatus(root, 'loading');
 
    const query = state.query.trim() || '*';
    const filterBy = buildFilterBy(root);
    const params = {
      q: query,
      query_by: state.config.queryBy,
      filter_by: filterBy,
      facet_by: FACET_FIELDS.join(','),
      max_facet_values: 100,
      per_page: state.perPage,
      page: state.page
    };
    const activeSort = effectiveSortBy(state, query);
    if (activeSort) params.sort_by = activeSort;
 
    const url = endpoint + '?' + serializeQueryParams(params);
 
    try {
      const response = await fetch(url, {
        headers: {
          'X-TYPESENSE-API-KEY': state.config.searchKey
        }
      });
 
      if (!response.ok) {
        throw new Error('Typesense request failed with status ' + response.status);
      }
 
      const payload = await response.json();
      const facetMap = parseFacetCounts(payload.facet_counts);
      FACET_FIELDS.forEach(function (field) {
        renderFacet(root, field, facetMap[field] || []);
      });
 
      const hits = Array.isArray(payload.hits) ? payload.hits : [];
      renderCards(root, hits);
      renderMeta(root, payload);
 
      if (hits.length === 0) {
        setStatus(root, 'empty');
      } else {
        setStatus(root, 'ok');
      }
    } catch (error) {
      setStatus(root, 'error');
      const errorEl = root.querySelector('[data-blog-error]');
      if (errorEl) {
        errorEl.textContent = 'Search is unavailable right now. Check Typesense settings.';
      }
      console.error(error);
    }
  }
 
  function bindFacetChange(root) {
    root.addEventListener('change', function (event) {
      const target = event.target;
      if (!(target instanceof HTMLElement)) return;
 
      if (target.matches('[data-blog-region-select]')) {
        const value = target.value || '';
        root._blogSearchState.selectedFacets.region = new Set(value ? [value] : []);
        root._blogSearchState.page = 1;
        runSearch(root);
        return;
      }
 
      if (target.matches('[data-blog-facet-input]')) {
        const field = target.getAttribute('data-field');
        const value = target.getAttribute('value');
        if (!field || !value) return;
 
        const selected = getSelectedSet(root, field);
        if (target.checked) {
          selected.add(value);
        } else {
          selected.delete(value);
        }
 
        root._blogSearchState.page = 1;
        runSearch(root);
      }
    });
  }
 
  function init(root) {
    const host = root.dataset.typesenseHost || '';
    const collection = root.dataset.typesenseCollection || '';
    const searchKey = root.dataset.typesenseSearchKey || '';
    const queryBy = root.dataset.queryBy || '';
    if (!host || !collection || !searchKey || !queryBy) {
      const summary = root.querySelector('[data-blog-summary]');
      if (summary) {
        summary.textContent = 'Set host, collection, key, and query fields in section settings.';
      }
      return;
    }
 
    root._blogSearchState = {
      config: {
        protocol: root.dataset.typesenseProtocol || 'https',
        host: host,
        port: root.dataset.typesensePort || '',
        path: root.dataset.typesensePath || '',
        collection: collection,
        searchKey: searchKey,
        queryBy: queryBy
      },
      perPage: Number(root.dataset.perPage || 12),
      query: '',
      sortBy: FEATURED_SORT,
      readTimeFilter: '',
      wordCountFilter: '',
      page: 1,
      totalPages: 1,
      selectedFacets: {}
    };
 
    hideRemovedFacets(root);
    buildTitleJump(root);
 
    const input = root.querySelector('[data-blog-search-input]');
    const sort = root.querySelector('[data-blog-sort]');
    const readTime = root.querySelector('[data-blog-read-time-filter]');
    const wordCount = root.querySelector('[data-blog-word-count-filter]');
    const clear = root.querySelector('[data-blog-clear]');
    const prev = root.querySelector('[data-blog-prev]');
    const next = root.querySelector('[data-blog-next]');

    if (sort) {
      sort.value = FEATURED_SORT;
      root._blogSearchState.sortBy = sort.value || FEATURED_SORT;
    }
 
    if (input) {
      input.addEventListener(
        'input',
        debounce(function () {
          root._blogSearchState.query = input.value || '';
          root._blogSearchState.page = 1;
          runSearch(root);
        }, 220)
      );
    }
 
    if (sort) {
      sort.addEventListener('change', function () {
        root._blogSearchState.sortBy = sort.value || '';
        root._blogSearchState.page = 1;
        runSearch(root);
      });
    }
 
    if (readTime) {
      readTime.addEventListener('change', function () {
        root._blogSearchState.readTimeFilter = readTime.value || '';
        root._blogSearchState.page = 1;
        runSearch(root);
      });
    }
 
    if (wordCount) {
      wordCount.addEventListener('change', function () {
        root._blogSearchState.wordCountFilter = wordCount.value || '';
        root._blogSearchState.page = 1;
        runSearch(root);
      });
    }
 
    if (clear) {
      clear.addEventListener('click', function () {
        root._blogSearchState.query = '';
        root._blogSearchState.sortBy = FEATURED_SORT;
        root._blogSearchState.readTimeFilter = '';
        root._blogSearchState.wordCountFilter = '';
        root._blogSearchState.page = 1;
        root._blogSearchState.selectedFacets = {};
 
        if (input) input.value = '';
        if (sort) sort.value = FEATURED_SORT;
        if (readTime) readTime.value = '';
        if (wordCount) wordCount.value = '';
 
        const jumpInput = root.querySelector('.blog-search__titlejump-input');
        const jumpList = root.querySelector('.blog-search__titlejump-list');
        if (jumpInput) jumpInput.value = '';
        if (jumpList) { jumpList.innerHTML = ''; jumpList.hidden = true; }
 
        runSearch(root);
      });
    }
 
    if (prev) {
      prev.addEventListener('click', function () {
        const state = root._blogSearchState;
        if (state.page <= 1) return;
        state.page = state.page - 1;
        runSearch(root);
      });
    }
 
    if (next) {
      next.addEventListener('click', function () {
        const state = root._blogSearchState;
        if (state.page >= state.totalPages) return;
        state.page = state.page + 1;
        runSearch(root);
      });
    }
 
    bindFacetChange(root);
    runSearch(root);
  }
 
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-blog-search-root]').forEach(init);
  });
})();